<template>
  <div id="template">
    <aside class="aside">
      <app-sidebar-header class="sidebar-header"></app-sidebar-header>
      <div class="sidebar">
        <app-home-sidebar class="home-sidebar"></app-home-sidebar>
      </div>
      <app-sidebar-footer class="sidebar-footer"></app-sidebar-footer>
    </aside>
    <section class="entry">
      <div class="search-member">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            v-model="search"
            placeholder="Find any family member"
            aria-label=""
            aria-describedby=""
            @keyup="display = true"
          />
        </div>
      </div>
      <div class="family-members" id="employees" v-if="display">
        <div class="row">
          <employee-card
            v-for="(employee, i) in filterEmployeeList"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email"
            :id="employee.id"
            :averageRating="employee.average_rating"
            :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
        <div class="family-members group" id="executive">
          <h2>
            Recently Joined Executive
            <span v-if="loadingExecutive"
              ><i class="fas fa-spinner fa-spin"></i
            ></span>
          </h2>
          <div class="row">
            <employee-card
              v-for="(employee, i) in executive"
              :key="i"
              :slug="employee.slug_name"
              :image="employee.profile_photo_file"
              :name="employee.name"
              :designation="employee.designation"
              :department="employee.department"
              :email="employee.office_email"
              :id="employee.id"
              :averageRating="employee.average_rating"
              :totalRatingProvider="employee.total_rating_provider"
            />
          </div>
        </div>
      </div>

      <div class="family-members group" id="faculty">
        <h2>
          Recently Joined Faculty
          <span v-if="loadingFaculty"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
        </h2>
        <div class="row">
          <employee-card
            v-for="(employee, i) in faculty"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email"
            :id="employee.id"
            :averageRating="employee.average_rating"
            :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
      </div>

      <div class="family-members group" id="officers">
        <h2>
          Recently Joined Officer
          <span v-if="loadingOfficer"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
        </h2>
        <div class="row">
          <employee-card
            v-for="(employee, i) in officers"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email"
            :id="employee.id"
            :averageRating="employee.average_rating"
            :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
      </div>

      <div class="family-members group" id="staff">
        <h2>
          Recently Joined Staff
          <span v-if="loadingStaff"
            ><i class="fas fa-spinner fa-spin"></i
          ></span>
        </h2>
        <div class="row">
          <employee-card
            v-for="(employee, i) in staff"
            :key="i"
            :slug="employee.slug_name"
            :image="employee.profile_photo_file"
            :name="employee.name"
            :designation="employee.designation"
            :department="employee.department"
            :email="employee.office_email"
            :id="employee.id"
            :averageRating="employee.average_rating"
            :totalRatingProvider="employee.total_rating_provider"
          />
        </div>
      </div>
      <app-footer class="footer"></app-footer>
    </section>
  </div>
</template>

<script>
import SidebarHeader from "./components/SidebarHeader.vue";
import SidebarFooter from "./components/SidebarFooter.vue";
import HomeSidebar from "./components/HomeSidebar.vue";
import Footer from "./components/Footer.vue";
import VLazyImage from "v-lazy-image";
import StarRating from "vue-star-rating";
import EmployeeCard from "./components/EmployeeCard.vue";

export default {
  components: {
    "app-footer": Footer,
    "app-sidebar-header": SidebarHeader,
    "app-sidebar-footer": SidebarFooter,
    "app-home-sidebar": HomeSidebar,
    "v-lazy-image": VLazyImage,
    "star-rating": StarRating,
    "employee-card": EmployeeCard
  },
  data() {
    return {
      search: "",
      employees: [],
      executive: [],
      faculty: [],
      officers: [],
      staff: [],
      display: true,
      isActive: false,
      loadingExecutive: false,
      loadingFaculty: false,
      loadingOfficer: false,
      loadingStaff: false
    };
  },
  name: "App",
  metaInfo() {
    return {
      meta: [
        {
          property: "og:image",
          content:
            "https://diu.ac/wp-content/themes/diu-theme-lite-v1/images/diu-logo-white.png"
        }
      ]
    };
  },
  mounted() {
    var current = this;

    axios.get("https://api.diu.ac/public/employees").then(function(response) {
      current.employees = response.data.data;
    });
  },
  computed: {
    filterEmployeeList() {
      return this.employees.filter(employee => {
        if (this.search != "") {
          return (
            employee.name.toLowerCase().includes(this.search.toLowerCase()) ||
            employee.office_email
              .toLowerCase()
              .includes(this.search.toLowerCase())
          );
        }
      });
    }
  },

  methods: {
    navClassHandeler(event) {
      if (this.activeLink) {
        this.activeLink.classList.remove("is-active");
      }
      this.activeLink = event.target;
      this.activeLink.classList.add("is-active");
    },

    toggleClass(event) {
      if (this.isActive) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },

    fetchExecutive() {
      var current = this;
      this.loadingExecutive = true;
      axios
        .get("https://api.diu.ac/public/executive")
        .then(function(response) {
          current.executive = response.data.data.slice(0, 3).reverse();
        })
        .finally(() => (this.loadingExecutive = false));
    },

    fetchFaculty() {
      var current = this;
      this.loadingFaculty = true;
      axios
        .get("https://api.diu.ac/public/faculty")
        .then(function(response) {
          current.faculty = response.data.data.slice(0, 3);
        })
        .finally(() => (this.loadingFaculty = false));
    },

    fetchOfficers() {
      var current = this;
      this.loadingOfficer = true;
      axios
        .get("https://api.diu.ac/public/officers")
        .then(function(response) {
          current.officers = response.data.data.slice(0, 4);
        })
        .finally(() => (this.loadingOfficer = false));
    },

    fetchStaff() {
      var current = this;
      this.loadingStaff = true;
      axios
        .get("https://api.diu.ac/public/staff")
        .then(function(response) {
          current.staff = response.data.data.slice(0, 3);
        })
        .finally(() => (this.loadingStaff = false));
    }
  },

  created() {
    this.fetchExecutive();
    this.fetchFaculty();
    this.fetchOfficers();
    this.fetchStaff();
  }
};
</script>



// WEBPACK FOOTER //
// src/Home.vue